import { useState } from 'react';


// components
import { Button } from 'shared/components/bulma/button';
import { ProductSearchInput } from './product-search-input';

import { toast } from "react-toastify";

import * as helper from "./helper";

const SwapItem = ({ barcode, onReplace }) => {
    const [loading, setLoading] = useState(false);
    const [replacementBarcode, setReplacementBarcode] = useState();

    const handleChange = async (event) => {
        const { value } = event.target;

        if (await helper.isReplacementProductAvailable(value)) {
            setReplacementBarcode(value);
        } else {
            toast.error(`Product ${value} is already in another box.`);
        }
    }

    const replace = async () => {
        if (!replacementBarcode) {
            return;
        }

        setLoading(true);
        await helper.replace(barcode, replacementBarcode);
        setLoading(false);
        setReplacementBarcode();

        if (onReplace) {
            onReplace();
        }
    }

    return (
        <div className="columns">
            <div className="column">
                <ProductSearchInput placeholder="Type barcode here"
                    id={`ps-${barcode}`} name="barcode" status="available" onChange={handleChange} />
            </div>
            <div className="column">
                <Button className={`is-dark ${loading ? 'is-loading' : ''}`} onClick={replace} disabled={loading}>
                    Replace
                </Button>
            </div>
        </div>
    )
};

export { SwapItem };
